import Api from "./Api";
import Api_2 from "./Api_extra";
import { createQueryString } from "./ApiHelper";

export default {
  GetSalesRegister(payload) {
    return Api_2().post(`/api/reports/salesRegisterReport`, payload);
  },
  GetSalesRegisterBeta(payload) {
    return Api_2().post(`/api/reports/salesRegisterReport-beta`, payload);
  },
  GetSalesRegisterBeta_Optimized(payload) {
    return Api_2().post(
      `/api/reports/salesRegisterReport_beta_optimized`,
      payload
    );
  },
  ItemSalesRegister(payload) {
    return Api_2().post(`/api/reports/itemSalesRegisterReport`, payload);
  },
  PollForSalesRegisterExcel(payload) {
    return Api_2().post(`/api/reports/check-sales-register-excel`, payload);
  },
  PollForSalesRegisterExcel_Optimized(payload) {
    return Api_2().post(`/api/reports/check-sales-register-excel`, payload);
  },
  GetGcamNewExcel(payload) {
    return Api().post(`api/reports/gcamReport`, payload);
  },
  GetTxSummaryGcam(payload) {
    return Api().post(`api/reports/getTxGcamReport`, payload);
  },
  GetNewRevenueReport(payload) {
    return Api_2().post(`api/reports/net-revenue-report`, payload);
  },
  GetReportBuilderFilter(payload) {
    return Api_2().get(`api/reports/report-builder-v2-filter`, payload);
  },
  GetReportBuilderData(payload) {
    return Api_2().post(`api/reports/report-builder-v2`, payload);
  },
  GetFoodCategoryAnalytics(payload) {
    return Api_2().post(`api/reports/fnb-category-analytics`, payload);
  },
  GetVoucherUseageReport(payload) {
    return Api_2().post(`api/reports/getVoucherUseageReport`, payload);
  },
  GetAdvanceFnBReport(payload) {
    return Api_2().post(`api/reports/getAdvanceFnbOnline`, payload);
  },
  GetEWalletReport(payload) {
    return Api_2().post(`api/reports/getEwalletReport`, payload);
  },
  GetSummaryV4(payload) {
    return Api().post(`api/reports/getSummariesV4`, payload);
  },
  GetTransactionSummary(payload) {
    return Api_2().post(`api/reports/getTransactionSummary`, payload);
  },
  GetTransactionSummaryV2(payload) {
    return Api_2().post(`api/reports/getTransactionSummaryV2`, payload);
  },
  GetPerformanceReportV5(payload) {
    return Api().post(`api/reports/getPerformanceReportV5`, payload);
  },
  GetConcessionPerformanceReportV5(payload) {
    return Api().post(`api/reports/getConcessionPerformanceReportV5`, payload);
  },
  GetOfferRedemptionReport(payload) {
    return Api_2().post(`api/reports/getOfferRedemptionReport`, payload);
  },
  GetMonthDayWiseReport(payload) {
    return Api_2().post(`api/reports/getMonthDayWiseReport`, payload);
  },
  GetEmpireInvoiceQRLogs(payload) {
    return Api().post(`api/reports/getInvoiceQRLogs`, payload);
  },
  GetFnbRefundReport(payload) {
    return Api().post(`api/reports/getFnbRefundReport`, payload);
  },
  GetDetailedAdvanceSalesReport(payload) {
    return Api_2().post(`/api/reports/getDetailedAdvanceSalesReport`, payload);
  },
  GetDetailedPriorSalesReport(payload) {
    return Api_2().post(`/api/reports/getDetailedPriorSalesReport`, payload);
  },
  GetSalesChannelPerformance(payload) {
    return Api().post(`api/reports/getSalesChannelWiseData`, payload);
  },
  GetElectronicPayments(payload) {
    return Api_2().post(`api/reports/getElectronicPaymentsReport`, payload);
  },
  GetUppLogs(payload) {
    return Api().post(`api/cinema/upp_loyality/getUppLogs`, payload);
  },
  ResendFailedUpp(payload) {
    return Api().post(`api/cinema/upp_loyality/resendUppLogs`, payload);
  },
  GetProductSaleReport(payload) {
    return Api_2().post(`api/reports/getProductSales`, payload);
  },
  GetDailyCashupReportReport(payload) {
    return Api().post(`/api/reports/getDailyCashupReport`, payload);
  },
  GetDailyCashupReportReportV2(payload) {
    return Api().post(`/api/reports/getDailyCashupReportv2`, payload);
  },
  GetCashierSessionReconcillation(payload) {
    return Api().post(`/api/reports/getCashierReconcillationReport`, payload);
  },
  GetDailyOperationsQueryData(payload) {
    return Api_2().post(`/api/reports/getDailyOperationsReport`, payload);
  },
  GetMovieWiseSummaryReport(payload) {
    return Api().post(`/api/reports/getMovieWiseSummaryReport`, payload);
  },
  GetUserCollectionReport(payload) {
    return Api().post(`/api/reports/getUserCollectionReport`, payload);
  },
  GetStaffPerfromanceReport(payload) {
    return Api_2().post(`/api/reports/getStaffPerformance`, payload);
  },
  GetTraffcAnalysis(payload) {
    return Api().post(`/api/reports/get-traffic-analysis`, payload);
  },
  GetFnbSalesAnalysis(payload) {
    return Api().post(`/api/reports/getFnBSalesAnalyticsReport`, payload);
  },
  GetOfferSalesReport(payload) {
    return Api().post(`/api/reports/get-offer-sales-report`, payload);
  },
  GetAuditLog(payload) {
    let qs = createQueryString(payload);
    return Api().get(`/api/reports/user-audit-logs${qs}`);
  },
  GetDcrAndPerformanceReport(payload) {
    return Api().post(`/api/reports/getDCRPerformanceReport`, payload);
  },
  GetSeatClassWiseSalesSummaryReport(payload) {
    return Api().post(
      `/api/reports/getSeatClassWiseSalesSummaryReport`,
      payload
    );
  },
  GetOccupancyAnalysis(payload) {
    return Api().post(`/api/reports/getOccupancyAnalysisReport`, payload);
  },
  GetTransactionRefunds(payload) {
    return Api_2().post(`/api/reports/getTransactionRefundsReport`, payload);
  },
  GetShowDateWiseAdmits(payload) {
    return Api().post(`/api/reports/getShowDateWiseAdmits`, payload);
  },
  GetNumeroData(payload) {
    return Api().post(`/api/reports/getTransactionDetailsForNumero`, payload);
  },
  GetOfflineOnlineTransactionReport(payload) {
    return Api_2().post(
      `api/reports/getOfflineOnlineTransactionReport`,
      payload
    );
  },
  GetFabOfferReport(payload) {
    return Api_2().post(`api/reports/getFabOfferReport`, payload);
  },
  getShiftLogsTransactions(payload) {
    return Api_2().post(`api/reports/getShiftLogsTransactions`, payload);
  },
  GetDailySalesCollectionV2(payload) {
    return Api().post(`/api/reports/daily-sales-collection-star-v2`, payload);
  },
  GetDrawerLogs(payload) {
    return Api_2().post(`/api/reports/getDrawerLogs`, payload);
  },
  getCustomerFnbTransactions(payload) {
    return Api_2().post(`/api/reports/getCustomerFnbTransactions`, payload);
  },
  GetMovieWiseCollectionReport(payload) {
    return Api_2().post(`/api/admin/v2/getMovieWiseCollectionReport`, payload);
  },
  GetWeekWiseMovieCollectionReport(payload) {
    return Api_2().post(`/api/admin/v2/getWeekWiseMovieWiseReport`, payload);
  },
  GetTransactionsMovieName() {
    return Api().post(`/api/admin/v2/getTransactionMovieName`);
  },
  getMovieSummaryReport(payload) {
    return Api_2().post(`/api/admin/v2/getMovieSummaryReport`, payload);
  },
  getOfflineOnlineTotalRevenueReport(payload) {
    return Api().post(
      `/api/reports/getOfflineOnlineTotalRevenueReport`,
      payload
    );
  },
  GetFnbOnlyPaymentsData(payload) {
    return Api().post(`/api/reports/getFnbOnlyPaymentsData`, payload);
  },
  GetMovieShowWiseReport(payload) {
    return Api().post(`/api/reports/getMovieShowWiseReport`, payload);
  },
  GetScheduleMovieList(payload) {
    return Api().post(`/api/reports/getScheduleMovieList`, payload);
  },
  getSinglePdfSummaryPerformance(payload) {
    return Api().post(
      `/api/reports/get-single-pdf-summary-performance`,
      payload
    );
  },
  GetComplimentaryData(payload) {
    return Api().post(`/api/reports/getComplimentaryReport`, payload);
  },
  getFnbCourtseyReport(payload) {
    return Api(payload).post(`/api/report/courtsey_fnb_report`, payload);
  },

  GetLoyaltyReport(payload) {
    return Api_2().post(`/api/reports/getLoyaltyReport`, payload);
  },
};




// WEBPACK FOOTER //
// ./src/services/NewReportService.js